
export function getElementHeight(el:HTMLElement):number|null {
  let height = null;
  if( el ) {
    let style = window.getComputedStyle(el);

    let marginTop = parseFloat(style.marginTop);
    let marginBottom = parseFloat(style.marginBottom);

    // console.log('marginTop:', marginTop);
    // console.log('marginBottom:', marginBottom);
    // console.log('offsetHeight:', el.offsetHeight);

    height = el.offsetHeight + marginTop + marginBottom;
  }

  return height;
}